import React from 'react';

const LandingDots = ({ width = 32, height = 44, color = '#DF444B' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 5.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM11 38.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM26.5 44a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
      fill={color}
    />
  </svg>
);

export default LandingDots;
